// extracted by mini-css-extract-plugin
export var badge = "_sl-4";
export var selected = "_sl-1";
export var selectedOverlay = "_sl-5";
export var thumbnailButton = "_sl-0";
export var thumbnailFallback = "_sl-3";
export var thumbnailImage = "_sl-2";